import styled from 'styled-components';
import { Fonts, Palette } from '../utils';

export const PickerRoot = styled.div`
  position: relative;
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
`;

export const IconPickerTrigger = styled.div`
  align-self: stretch;
  width: 100%;
  padding: 12px 16px;
  background: ${Palette.SOLITUDE};
  border-radius: 8px;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  box-sizing: border-box;
  cursor: ${(p) => (p.$disabled ? 'not-allowed' : 'pointer')};
  outline: none;

  ${(p) =>
    p.$hasError ? `box-shadow: inset 0 0 0 2px ${Palette.ERROR};` : ''}

  &:focus-visible {
    box-shadow: ${(p) =>
      p.$hasError
        ? `inset 0 0 0 2px ${Palette.ERROR}, inset 0 0 0 4px ${Palette.OCEANIC}`
        : `inset 0 0 0 2px ${Palette.OCEANIC}`};
  }
`;

export const TriggerTextInput = styled.input`
  flex: 1;
  width: 100%;
  min-width: 0;
  border: none;
  background: transparent;
  color: ${Palette.BLACK_50};
  font-size: 14px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 400;
  line-height: 24px;
  outline: none;

  &::placeholder {
    color: ${Palette.BLACK_50};
  }

  &:focus {
    color: ${Palette.BLACK};
  }
`;

export const DropdownPanel = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 6px);
  z-index: 10050;
  padding: 12px 16px;
  background: ${Palette.WHITE};
  border-radius: 10px;
  border: 0.5px solid ${Palette.BORDER_OUTLINE};
  box-sizing: border-box;
  max-height: min(320px, 55vh);
  overflow-y: auto;
`;

export const TileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  column-gap: 6px;
  row-gap: 8px;
  align-content: start;
`;

export const TileButton = styled.button`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  padding: 2px 0 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  box-sizing: border-box;
  outline: none;

  &:focus-visible {
    box-shadow: inset 0 0 0 2px ${Palette.OCEANIC};
    border-radius: 8px;
  }
`;

export const TileIconArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  width: 100%;
`;

export const TileLabel = styled.div`
  align-self: stretch;
  width: 100%;
  text-align: center;
  color: ${(p) => (p.$selected ? Palette.BLACK : Palette.BLACK_50)};
  font-size: 11px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: ${(p) => (p.$selected ? 600 : 400)};
  line-height: 1.3;
  word-break: normal;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
`;
